import { createId } from '@paralleldrive/cuid2';

import { Player, Shelf } from '@/types/Configuration';
import { Flex } from '@/ui/Flex/Flex';

import { AddButton } from '../../AddButton/AddButton';
import { TableCell } from '../TableCell/TableCell';

type Props = {
  readonly saveShelfPlayers: (shelves: readonly Shelf[]) => void;
  readonly shelves: readonly Shelf[];
  readonly subsidiaryId: string;
};

export const PlayerColumn = ({
  saveShelfPlayers,
  shelves,
  subsidiaryId,
}: Props) => {
  const shelvesPlayers = shelves.map(
    ({ id: shelfId, name: shelfName, players }) => ({
      shelfId,
      players: players.map((player) => ({ ...player, shelfName })),
    }),
  );

  return (
    <Flex direction="column" gap={16}>
      {shelvesPlayers.map(({ shelfId, players }) => (
        <>
          {players.map((player) => (
            <TableCell
              columnName="Subsidiary"
              item={player.hostname}
              key={player.id}
              onDelete={() => {
                const newPlayers = players.filter(
                  ({ id: playerId }) => playerId !== player.id,
                );

                const newShelves = shelves.map((editShelf) =>
                  editShelf.id === shelfId
                    ? {
                        ...editShelf,
                        players: newPlayers,
                      }
                    : editShelf,
                );

                saveShelfPlayers(newShelves);
              }}
              onEdit={(playerName) => {
                const newPlayers = players.map((editPlayer) =>
                  editPlayer.id === player.id
                    ? {
                        ...editPlayer,
                        hostname: playerName,
                      }
                    : editPlayer,
                );

                const newShelves = shelves.map((editShelf) =>
                  editShelf.id === shelfId
                    ? {
                        ...editShelf,
                        players: newPlayers,
                      }
                    : editShelf,
                );

                saveShelfPlayers(newShelves);
              }}
            />
          ))}

          <AddButton
            columnName="Player"
            onSave={(playerName, isManaged = false) => {
              const newPlayers = [
                ...players,
                {
                  id: createId(),
                  customer: 'le_customer',
                  fleet: 'g_lukas_knutti/test_sammy',
                  archived: false,
                  hostname: playerName,
                  shelfId,
                  subsidiary: subsidiaryId,
                  deviceUuid: '',
                  isOnline: false,
                  isDevManaged: isManaged,
                } as Player,
              ];

              const newShelves = shelves.map((editShelf) =>
                editShelf.id === shelfId
                  ? {
                      ...editShelf,
                      players: newPlayers,
                    }
                  : editShelf,
              );

              saveShelfPlayers(newShelves);
            }}
          />
        </>
      ))}
    </Flex>
  );
};
